import { createContext } from 'react';
import { Comp } from '../components/page-view/types';

export type PageContextValueType = {
  coms: Comp[];
};

const pageContext = createContext<PageContextValueType>({
  coms: [],
});

export const PageProvider = pageContext.Provider;

export default pageContext;
